import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  root: {
    "&.MuiGrid-root": {
      // width: "100dvw",
      // height: "100dvh",
      backgroundColor:'white',
      display:'flex',
      flexDirection:'column'
    },
  },
  titleInfo: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "space-between",
      height: "40px",
      width: "100%",
      alignItems: "center",
      paddingInline: "10px",
      backgroundColor: "#F3CCF3",
      
    },
  },
  tableInput: {
    "&.MuiTextField-root": {
      "& .MuiOutlinedInput-root": {
        // backgroundColor:theme.palette.grey[50],
        "& fieldset": {
          borderColor:"none",
          // borderWidth:'1.4px',
          border: "none",
        },
        '&:hover fieldset': {
          borderColor:"none",
          border:'none',
          // borderWidth:'1.4px',
        },
        "&.Mui-focused fieldset": {
              borderColor: "none !important",
              boxShadow: "none !important",
              borderWidth: "0 !important",
            },
      },
      "& .MuiInputBase-input": {
        color: "none",
        border: "none",
      },
      "& .MuiInputLabel-root": {
        color: "none",
        border: "none",
      },
    },
  },
  contentGrid: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "space-between",
      height: "calc(100% - 40px)",
      width: "100%",
    },
  },
  tblRoot: {
    "&.MuiTableContainer-root": {
      // height: "100%",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&:hover::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[100],
      },
      "&::-webkit-scrollbar-thumb": {
        border: "2px solid #A9A9A9",
        borderRadius: "20px",
        backgroundColor: theme.palette.common.white,
        backgroundClip: "content-box",
      },
    },
  },
  table: {
    position: "relative",
    // outline: `0.5px solid #ccc`,
    borderRadius: "4px",
  },
  tablrow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        padding: "5px",
        borderRight: `1px solid #ccc`,
      },
    },
  },
  tblHeader: {
    "&.MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 600,
        backgroundColor: "#ba68c8",
        paddingBlock: "6px",
        color: "#fff",
        letterSpacing: 1,
      },
    },
  },
  fieldBox: {
    "&.MuiTextField-root": {
      height: "20px",
      backgroundColor: "red",
    },
  },
  tblContentCell: {
    "&.MuiTableCell-root": {
      textAlign: "center",
      padding: "0px",
      borderBottom:'0.5px solid  #ccc',
      "& .MuiTextField-root": {
        textAlign:"center",
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: 0,
          // backgroundColor: theme.palette.grey[50],
          "& fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&:hover fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
        },
      },
      // border: `1px solid #ccc`,
    },
    
  },
  searchTextField: {
    "&.MuiTextField-root": {
      maxWidth: 400,
      width: "100%",
      [theme.breakpoints.down(768)]: {
        paddingInline: 0,
        width: "100%",
      },
    },
  },
  // customtextfield: {
  //   "&.MuiTextField-root": {
  //     width: "220px",
  //     marginBlockStart: "5px",
  //     [theme.breakpoints.down(728)]: {
  //       width: "100%",
  //     },
  //   },
  // },
dropDown:{
  zIndex : 1500,
  position : 'absolute',
  width:"27%"
},
paperGrid:{
'&.MuiPaper-root':{
  width:'75%',
  height:'60dvh',
  paddingInline:5
}
},
qrCodeGrid:{
  '&.MuiGrid-root':{
  "&::-webkit-scrollbar": {
    display: "none",
  },
  }
}
}));

// .MuiTableContainer-root .MuiTableBody-root .MuiTableHead-root .MuiTableHead-root .MuiTableRow-root
